import { PlayerCardType } from "@/src/types/Embeds";
import { TeamsColorsList } from "@/src/utils/teams";
import Image from "next/image";
import { getTeamLogo, renderStats } from "./utils";

export interface PlayerCardProps {
  cardData: PlayerCardType;
}

const SmallPlayerCard = ({ cardData }: PlayerCardProps) => {
  //@ts-ignore
  const colors = TeamsColorsList[cardData.team]
    ? //@ts-ignore
      TeamsColorsList[cardData.team]
    : ["", ""];

  return (
    <div className="rounded small-player-card shadow-lg">
      <div className="w-full h-full relative">
        <div
          className="player-image-container rounded"
          style={{
            background: `linear-gradient(120deg, ${colors[0]} 0%, ${colors[0]} 50%, ${colors[1]} 50%)`,
          }}
        >
          <div className="team-logo-container absolute top-2 left-2">
            <div className="team-logo w-[70px] h-[70px] md:w-[120px] md:h-[120px] relative">
              <Image
                //@ts-ignore
                src={getTeamLogo(cardData.team)}
                fill
                //@ts-ignore
                alt={`${cardData.team} logo`}
              />
            </div>
          </div>
          <div className="image-container relative w-[200px] h-[200px] md:w-[210px] md:h-[220px] mt-auto ml-auto mr-auto">
            <Image
              //@ts-ignore
              src={cardData.photo}
              fill
              alt={`${cardData.name} image`}
            />
          </div>
        </div>
        <div className="name-container w-full text-center">
          <h2 className="text-xl font-bold py-2">{cardData.name}</h2>
        </div>
        <div className="stats-container flex flex-col p-2">
          {
            //@ts-ignore
            renderStats(cardData.stats)
          }
        </div>
      </div>
    </div>
  );
};

export default SmallPlayerCard;
